<template>
  <div class="mcluster-introduce-background">
    <div class="mcluster-introduce-banner">
      <div class="mcluster-introduce-container">
        <div class="mcluster-introduce-banner-title">MCLUSTER</div>
      </div>

      <img class="mcluster-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mcluster-introduce-container">

     <div class="mcluster-introduce-content">
       <div class="mcluster-introduce-content-title">
         <div class="mcluster-introduce-content-title-text">龙讯黑科技：X-Mcluster</div>
         <div class="mcluster-introduce-line"></div>
       </div>
       <div class="mcluster-introduce-content-info">
         <p class="mcluster-introduce-content-info-text">经过多年的硬件测试和软件开发经验，今天我们荣幸地推出了龙 讯的最新产品，软硬一体化平台产品MCluster。MCluster由12台Mstation、1台96T的存储以及一个管理节点组成，每台Mstation包括双路16核Intel至强处理器和4路Nvidia最新旗舰级显卡（GTX1080Ti）。同时，每台Mstation之间通过超高速Infiniband网络进行数据传输。MCluster系统总功率在10000W左右，占地面积极小，可安装在小房间内（具体见下图所示）。经过不断优化，龙讯的核心软件PWmat装在MCluster上，表现出不俗的效果，充分表现出”小身材，大能量”， 可与几千CPU核的超级计算机媲美。除了48 个GPU，MCluster 还包括192 CPU核，所以也可以用于大量其他的纯CPU程序计算。</p>
       </div>

       <div class="mcluster-introduce-content-img">
         <img class="mcluster-introduce-content-img-png" style="margin-top: 0;vertical-align: top;display: inline-block;margin-right: 50px" src="../../assets/produce/mcluster/mcluster_product.jpg">
         <img class="mcluster-introduce-content-img-png" style="display: inline-block;vertical-align: top" src="../../assets/produce/mcluster/mcluster_product_2.jpg">
       </div>


       <div class="mcluster-introduce-content-info">
         <p class="mcluster-introduce-content-info-text">部署PWmat后的“MCluster”在材料计算领域用途广泛，最典型的一个应用就是材料基因组计算。一台MCluster能够同时计算48个不同系统，这对于材料基因组开发，高通量计算、数据库建设、材料搜索都有极大的助益。目前最成功的案例就是北京大学深圳研究生院通过MCluster平台产生的材料数据库。在龙讯的帮助下，北大深圳研究生院建立了世界上首个HSE（杂化泛函）材料能带数据库。通过MCluster平台，每周能够为数据库产生超过一千个晶体结构的数据。MCluster+PWmat平台加上相对应的自动化工作流框架, 使这一套系统成为完成材料基因组项目的不可多得的有力工具。更多信息可详见<a class="mcluster-introduce-href" href="http://www.pkusam.com/bdm/">北大新材料</a>。</p>
         <p class="mcluster-introduce-content-info-text">但是今天我们着重要讲的不是高通量计算，那已经是“龙讯”的成熟产品；我们要给大家介绍的是：基于“MCluster”的超大体系计算。经过在“MCluster”上的深度测试，我们发现使用48个GPU能够计算高达5000个原子（20000个电子以上）的体系，其中一个典型的例子就是5120个Si原子的体系。在“MCluster”上，这样一个体系自洽计算足够收敛，仅仅需要3个小时。为了证明PWmat对大体系计算的准确性，我们计算了一个带点缺陷的4096 Si原子的体材料体系 （见图），计算了该缺陷体系中费米面附近部分占据态（open shell）上电子的波函数，如下图2所示。另外我们也对1000个水分子（3000个原子，见图）的体系进行了第一性原理的分子动力学模拟：每一步分子动力学仅需要2.5分钟。这样的速度十分令人鼓舞，它已经接近原子基组方法的模拟规模和速度，但却不必担心可能由于基组不准而带来的误差。上面的例子是至今为止最大的平面波系统计算之一。比如2011年Gordon Bell prize, 计算了一个10,000 个Si原子的量子线，用了实空间方法，用的n1,n2,n3 要比我们5000 Si 原子的n1,n2,n3 小八倍， 在当时世界最大的日本超级计算机“京””上计算，做一个自洽计算还需要24 小时。又比如，2006年的Gordon Bell prize，用平面波程序Qbox计算了一个1000 原子molybdenum的系统，总共有12,000 电子，用了整个BlueGene/L机器(当时世界上最快的计算机， 65,536 nodes）， 每一步自洽计算大致需要220秒 （按每一步SCF自洽由4步steepest decent steps 组成来估计）。相反，我们的Mcluster+PWmat, 计算一个3000 原子的Si 系统， 也是12,000 电子，每一步自洽计算只需要100秒 。 对于现有的开源和商业平面波基组模拟计算软件， 要完成这样的超大体系计算也并不容易，甚至无法实现。例如在众所周知的广州超算“天河二号”上，通过对公认最强的商业平面波计算软件进行反复测试，我们发现无论使用多少核（最大到几千核），4000个Si原子的体系始终无法运行，最多只能运行2000到3000个Si原子。使用2000个CPU来计算这个2000 个Si原子系统，使用默认的设置，此软件需要至少半个小时才能完成整个自洽计算。 但同样的系统和任务，在MCluster+PWmat上来计算，总共只需要8分钟。具体测试数据详见下面表格：</p>
       </div>


       <div class="mcluster-introduce-content-info">
         <table class="mcluster-introduce-table">
           <tr class="mcluster-introduce-th">
             <th class="mcluster-introduce-text-th">测试体系</th>
             <th class="mcluster-introduce-text-th">原子数</th>
             <th class="mcluster-introduce-text-th">电子数</th>
             <th class="mcluster-introduce-text-th">截断能(eV)</th>
             <th class="mcluster-introduce-text-th">赝势</th>
             <th class="mcluster-introduce-text-th">时间（充分收敛）</th>
           </tr>
           <tr class="mcluster-introduce-td" v-for="param in mclustertParams">
             <td class="mcluster-introduce-text-td">{{param.testSystem}}</td>
             <td class="mcluster-introduce-text-td">{{param.atomicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.electronicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.truncationCan}}</td>
             <td class="mcluster-introduce-text-td">{{param.turns}}</td>
             <td class="mcluster-introduce-text-td">{{param.time}}</td>
           </tr>
         </table>
       </div>

       <div class="mcluster-introduce-content-img">
         <img class="mcluster-introduce-content-img-png" src="../../assets/produce/mcluster/mcluster_product_3.jpg">
       </div>

       <div class="mcluster-introduce-content-info">
         <p class="mcluster-introduce-content-info-text">上面的测试结果是令人激动的。 我们希望它给我们的用户带来新的研究机会和方向，让我们的用户在科研竞争中胜人一筹。比起国家级的超级计算机，MCluster的价格相对低廉，只需两百多万，是大多数课题组和院系都负担得起的。随着材料科学研究进入到多尺度系统，越来越复杂的超大体系模拟计算正逐渐成为一种必要。在过去，由于资源有限，也没有相应的软件，这方面的研究无法展开。希望MCluster + PWmat的出现成为大家打开梦想大门的钥匙。MCluster + PWmat，双剑合璧，令您的科研如虎添翼。</p>
         <p class="mcluster-introduce-content-info-text">如果您对我们的产品“MCluster”感兴趣，或打算把“MCluster”写到计划书里面，请您务必发邮件到<a class="mcluster-introduce-href" href="mailto:support@pwmat.com">support@pwmat.com</a>，来邮必复！我们会帮助您量身定制属于您自己的材料计算黑科技“X-MCluster”。</p>
         <p class="mcluster-introduce-content-info-text">无可比拟，前所未有。</p>
       </div>

     </div>
    </div>
  </div>
</template>

<script>
  import {MCLUSTERTable} from '../../helpers/productParam'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        mclustertParams:''
      }
    },
    created(){
      this.mclustertParams = MCLUSTERTable
    },
  }
</script>

<style scoped>
  .mcluster-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .mcluster-introduce-background{
    margin-top: 70px;
  }
  .mcluster-introduce-banner{
    overflow:hidden;
  }
  .mcluster-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .mcluster-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .mcluster-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .mcluster-introduce-content-img{
    text-align: center;
  }
  .mcluster-introduce-content-img-png{
    margin-top: 50px;
    width: 300px;
  }
  .mcluster-introduce-content-title{
    padding-top: 50px;
  }
  .mcluster-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .mcluster-introduce-content-info{
    margin-top: 40px;
  }
  .mcluster-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .mcluster-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .mcluster-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mcluster-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mcluster-introduce-td{
    height: 45px;
  }
  .mcluster-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mcluster-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mcluster-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mcluster-introduce-href{
    color: rgba(73,145,201,1);
  }
  @media screen and (max-width:482px) {
    .mcluster-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .mcluster-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .mcluster-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .mcluster-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .mcluster-introduce-container{
      max-width: 1068px;
    }
  }

</style>